<template lang="pug">
  v-container(fluid)
    h1.text-center {{ translations.title }}

    v-row.px-2.px-sm-10.py-10(align="center" justify="center")
      v-col(cols="12")
        h5 {{ translations.titleAll }}
      v-col(cols="12")
        v-data-table(
          :headers="headers"
          :items="datos" 
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
          )
          template(v-slot:body="{ items }")
            tbody
              tr(v-for="item,ind in items"  :key="'item'+ind")
                td
                  span.fantasy__block-width--8 {{ item.name }}
                td
                  span.fantasy__block-width--8 {{ item.sport }}
                td
                  BaseConfirmDialog(v-if="hasPermission('views.fantasy.competitions.toggleCompetition')" @confirm="toggleState(item._id)" v-bind="translations.confirmationDialog.status")
                    template(v-slot="{ on }")
                      v-btn(v-on="on" :color="getColor(item.status.value)" :loading="loadingToggleCompetition" dark rounded) {{ item.status.text }}
                  v-chip(v-else :color="getColor(item.status.value)" text-color="white") {{ item.status.text }}
                td {{ item.country }}
                td {{ item.season }}
                td
                  v-btn(@click="linkMatches(item._id)" color="primary" text) {{ translations.buttonMatches }}
                td
                  v-btn(@click="linkTeams(item._id)" color="primary" text) {{ translations.buttonTeams }}
                td(v-if="hasPermission('views.fantasy.competitions.editCompetition')")
                  BaseDialog(type="edit", :title="translationsForm.title.edit+': '+item.name" v-slot="{close, opened}")
                    CompetitionEdit(@successEdit="updateCompetitions(opened,close)", :clearForm="opened", :competition="item", :providers="providers", :sports="sports", :translations="translationsForm")
      BaseDialog(v-if="hasPermission('views.fantasy.competitions.createCompetition')" type="create", :title="translationsForm.title.create" v-slot="{close, opened}")
        CompetitionCreate(@successCreate="updateCompetitions(opened,close)", :clearForm="opened", :providers="providers", :sports="sports", :translations="translationsForm")

</template>

<script>

  import CompetitionCreate from "@/components/forms/CompetitionCreate";
  import CompetitionEdit from "@/components/forms/CompetitionEdit";
  import { providers, sports } from "@/store/variablesGlobals";

  export default {
    name: 'FantasyCompetitionsIndex',
    components: {
      CompetitionCreate,
      CompetitionEdit,
    },
    // data:() => ({
    //   providers: providers,
    // }),
    computed: {
      translations(){
        return this.$t("views.competitionsIndex");
      },
      translationsForm(){
        return this.$t("forms.competition");
      },
      sports(){
        return sports(this.$i18n.locale);
      },
      providers(){
        return providers;
      },
      headers(){
        let headers =  [
          {
            text: this.translations.tableHeadText.name,
            value: 'name'
          },
          {
            text: this.translations.tableHeadText.sport,
            value: 'sport'
          },
          {
            text: this.translations.tableHeadText.status,
            value: 'status',
            sortable: false
          },
          {
            text: this.translations.tableHeadText.country,
            value: 'country'
          },
          {
            text: this.translations.tableHeadText.season,
            value: 'season'
          },
          {
            text: '',
            value: 'matches',
            sortable: false
          },
          {
            text: '',
            value: 'teams',
            sortable: false
          },
        ];
        if(this.hasPermission('views.fantasy.competitions.editCompetition')){
          headers.push(
            {
              text: '',
              value: 'edit',
              sortable: false
            });
        }
        return headers;
      },
      datos(){
        const vm = this;
        return this.competitionListAll.map(competition =>{
          return {
            _id: competition._id,
            name: competition.name,
            sport: competition.sport == '' || competition.sport == undefined ? '' : vm.$t('back.sport.'+ competition.sport),
            status:{
              text: competition.enabled != undefined ? vm.$t('back.states.'+ competition.enabled) : '',
              value: competition.enabled
            },
            season: competition.provider != undefined ? competition.provider.s : '',
            country: competition.country.name,
            countryCode: competition.country.iso,
            provider: competition.provider != undefined ? competition.provider.code : '',
            providerId: competition.provider != undefined ? competition.provider.id : '',
            futmondo: competition.futmondo,
          }
        })
      },
      competitionListAll() {
        return this.$store.state.fantasy.competitions;
      },
      loadingToggleCompetition(){
        return this.$store.state.statusCode.toggleCompetition.loading;
      },
      statusToggleState(){
        return this.$store.state.statusCode.toggleCompetition.state || '';
      },
    },
    watch: {
      statusToggleState: function(val){
        if (val == 200){
          this.$store.dispatch('getCompetitions');
        }
      },
    },
    created(){
      this.$store.dispatch('getCompetitions');
    },
    methods:{
      linkMatches(competitionid){
        this.$router.push('/fantasy/matches/'+competitionid);
      },
      linkTeams(competitionid){
        this.$router.push('/fantasy/teams/'+competitionid);
      },
      linkCreate(){
        this.$router.push('/fantasy/contest/create');
      },
      getColor(type){
        return type ? 'green': 'red';
      },
      toggleState(competitionid){
        this.$store.dispatch('toggleCompetition', competitionid);
      },
      updateCompetitions(opened, closedialog){
        if(opened) {
          if(closedialog != undefined){
            closedialog();
          }
          this.$store.dispatch('getCompetitions');
        }
      },
    }
  }
</script>


<style lang="sass">
</style>